import React from "react";
import ReturnNote from "./ReturnNote";

/**
 * CnExNote — shared receipt view for Credit Note + Exchange Note.
 *
 * This is a thin wrapper around `ReturnNote` so OrderReturn and ReturnNotePrint
 * can import a single component without caring about note type.
 */
function CnExNote(props) {
  return <ReturnNote {...props} />;
}

export default CnExNote;

